import { render, staticRenderFns } from "./LaudoConformidadeAmbiental.vue?vue&type=template&id=4569df1a&scoped=true&lang=pug"
import script from "./LaudoConformidadeAmbiental.vue?vue&type=script&lang=js"
export * from "./LaudoConformidadeAmbiental.vue?vue&type=script&lang=js"
import style0 from "./LaudoConformidadeAmbiental.vue?vue&type=style&index=0&id=4569df1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4569df1a",
  null
  
)

export default component.exports